module.exports = __webpack_public_path__ + "img/lotery-rewards-4.049cd5e4.webp";